import { render, staticRenderFns } from "./ModalSKHistory.vue?vue&type=template&id=38b17c28&scoped=true&"
import script from "./ModalSKHistory.vue?vue&type=script&lang=js&"
export * from "./ModalSKHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModalSKHistory.vue?vue&type=style&index=0&id=38b17c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b17c28",
  null
  
)

export default component.exports